import firebase from "firebase/compat/app";
import formatUserData from "../utils/formatUserData";

const getUserCoachList = async function(orgId) {
  let db = firebase.firestore();
  const userList = [];
  const userSnapshot = await db
    .collection("wellness_users")
    .where("permissions", "array-contains", "accessCoachAdmin")
    .where("orgId", "==", orgId)
    .get();

  userSnapshot.forEach((doc) => {
    userList.push(formatUserData(doc.id, doc.data()));
  });
  return userList;
};

export default getUserCoachList;
